import { useRef } from 'react'

import {
  ITooltip as ReactTooltipProps,
  Tooltip as ReactTooltip,
  TooltipRefProps,
} from 'react-tooltip'
import styled, { css } from 'styled-components'

import { themed } from '../Theme'

export interface ITooltipProps {
  id?: string
  place?: 'top' | 'bottom' | 'left' | 'right'
}

export const StyledReactTooltip = themed(styled<TooltipRefProps>(ReactTooltip)`
  ${({ theme }) => css`
    background: ${theme.whiteColor};
    color: ${theme.grey900Color};
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.5rem 0 rgb(0 0 0 / 10%);
    font-size: 0.75rem;
    line-height: 1.17;
    letter-spacing: 0.3px;
    padding: 0.25rem 0.5rem;
    z-index: 99;
  `};
`)

export const Tooltip: React.FC<ITooltipProps & ReactTooltipProps> = ({ ...props }) => {
  const tooltipRef = useRef<TooltipRefProps>(null)

  const { ...otherProps } = props

  return (
    <StyledReactTooltip
      id={props.id ?? 'base-tooltip'}
      data-testid="base-tooltip"
      ref={tooltipRef}
      place={props.place ?? 'right'}
      variant="light"
      disableStyleInjection
      effect="solid"
      opacity={1}
      {...otherProps}
    />
  )
}
